import { Component, OnInit } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { BusinessService } from '../../../../common/services/Business.service';
import { SettingService } from '../../../../common/services/Setting.service';
import { UploadService } from '../../../../common/services/Upload.service';
import { Location } from '@angular/common';
import { EvsAddressService } from '../../../../common/services/EvsAddress.service';
import { ToastrService } from 'ngx-toastr';
import { ImageService } from '../../../imageService';
import { TranslateService } from '@ngx-translate/core';

declare var $: any;

@Component({
  // tslint:disable-next-line:component-selector
  selector: 'distribution-service',
  templateUrl: 'distribution-service.templete.html',
  styleUrls: ['./business.css'],
  providers: [BusinessService, EvsAddressService, UploadService, ImageService, SettingService],
})
export class DistributionServiceComponent implements OnInit {
  public dataSetting: any;

  constructor(
    private _fb: FormBuilder,
    private businessService: BusinessService,
    private addressService: EvsAddressService,
    private upload: UploadService,
    private _location: Location,
    private toastr: ToastrService,
    private settingService: SettingService,
    private translate: TranslateService,
  ) {
  }

  // tslint:disable-next-line:member-ordering
  formCratingBatch: FormGroup = this._fb.group({
    is_cratingStamps: ['routing'],
    is_agency: ['yesRouting'],
  });

  ngOnInit() {
    this.getList();
  }

  reset(e) {
    this.formCratingBatch.get('is_cratingStamps').setValue(e);
  }

  reset2(e) {
    this.formCratingBatch.get('is_agency').setValue(e);
  }

  getList() {
    this.settingService.getTransferSetting().subscribe(
      (res: any) => {
        if (res.code == 1 && res.data) {
          this.dataSetting = res.data;
          if (this.dataSetting.transfer_type || this.dataSetting.transfer_type === 0) {
            this.formCratingBatch.get('is_cratingStamps').setValue(this.dataSetting.transfer_type === 1 ? 'routing' : 'notRouting');
          }
          if (this.dataSetting.transfer_verify_type || this.dataSetting.transfer_verify_type === 0) {
            this.formCratingBatch.get('is_agency').setValue(this.dataSetting.transfer_verify_type === 0 ? 'yesRouting' : 'noRouting');
          }
          console.log(' this.formCratingBatch', this.dataSetting)
        } else {
          this.toastr.error(this.translate.instant('CO_LOI_XAY_RA'), this.translate.instant('THONG_BAO_COLON'), {
            timeOut: 4000,
            positionClass: 'toast-top-right',
          });
        }
      },
      (err: any) => {
        this.toastr.error(err, this.translate.instant('THONG_BAO_COLON'), {
          timeOut: 4000,
          positionClass: 'toast-top-right',
        });
      }
    );
  }

  changeConfig() {
    const body = {
      transfer_type: this.formCratingBatch.value.is_cratingStamps ? this.formCratingBatch.value.is_cratingStamps === 'routing' ? 1 : 0 : null,
      transfer_verify_type: this.formCratingBatch.value.is_agency ? this.formCratingBatch.value.is_agency === 'yesRouting' ? 0 : 1 : null
    }
    // @ts-ignore
    this.settingService.postTransferSetting(body).subscribe((res) => {
      if (res.code === 1) {
        this.toastr.success(this.translate.instant('THANH_CONG'), this.translate.instant('THONG_BAO'), {
          timeOut: 4000, positionClass: 'toast-bottom-right'
        })
        this.getList();
      }
    }, (err: any) => {
      this.toastr.success(err, this.translate.instant('THONG_BAO'), {
        timeOut: 4000, positionClass: 'toast-bottom-right'
      })
    })
  }
}



// WEBPACK FOOTER //
// /app/src/app/pages/admin/evs/business/distribution-service.component.ts